<template>
  <li class="k__menu__item">
	<a
		v-if="!menu.dropdown || menu.dropdown.length == 0"
		:href="menu.url"
		class="k__menu__link"
		:class="{
			'k__meu__link--active': menu.active,
			'active': menu.active,
		}"
		:aria-current="menu.active ? 'page' : null"
	>{{ menu.text }}</a>

	<div class="k__menu__item__dropdown" v-else>
		<div class="k__menu__item__dropdown__ctrl">
			<a
				:href="menu.url"
				class="k__menu__link"
				:id="`menu-label-${dropID}`"
				:class="{
					'k__meu__link--active': menu.active,
					'active': menu.active,
				}"
				:aria-current="menu.active ? 'page' : null"
			>{{ menu.text }}</a>

			<button
				class="k__menu__btn"
				data-bs-toggle="collapse"
				:data-bs-target="`#menu-${dropID}`"
				aria-expanded="false"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
				</svg>
			</button>
		</div>

		<ul
			v-if="menu.dropdown"
			class="k__menu__dropdown collapse"
			:id="`menu-${dropID}`"
			:aria-labelledby="`menu-label-${dropID}`"
		>
			<KMenuItem
				v-for="drop in menu.dropdown"
				:key="drop.id"
				:menu="drop"
			/>
		</ul>
	</div>
  </li>
</template>

<script setup>
import  { v4 as uuid } from 'uuid'

const props = defineProps({
	menu: {
		type: Object,
		default: ()=> ({})
	}
})

const dropID = uuid()
</script>

<style lang="scss">
.k__menu__item__dropdown__ctrl{
	display: flex;

	.k__menu__link {
		flex-grow: 1;
	}
}
</style>
